import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './assets/styles/index.css';
import logout from "./_functions/logout"
import Schema from "./helpers/schema"
import MCRequests from "./requests/mc-requests"
import logErrorToSlack from "./_functions/log-error-to-slack"
import checkIfBankBilletIsEnabled from "./_functions/checkIfBankBilletEnabled"



const rootEl = document.getElementById('root')

const props = {
    logout,
    getSchema: Schema.get,
    schemaInfo: Schema.searchInfo,
    getSystemParams:  MCRequests.getSystemParams,
    getCentralConfig: ()=>MCRequests.getSystemConfig('PARAM_CENTRAL_CONFIG'),
    getPaymentPartnerCode: ()=>MCRequests.getSystemConfig('PARAM_PAYMENT_PARTNER_CODE'),
    checkIfBankBilletIsEnabled: checkIfBankBilletIsEnabled(MCRequests.getSystemConfig),
    logError: logErrorToSlack,

}


ReactDOM.render(
    <App {...props}/>,
    document.getElementById('root')
)

if (module.hot) {
    module.hot.accept('./App', () => {
        const NextApp = require('./App').default
        ReactDOM.render(
            <NextApp  {...props}/>,
            rootEl
        )
    })
}



// WEBPACK FOOTER //
// ./src/index.js